import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const LoginChartAnimation = () => (
  <ChartWrap aria-hidden="true">
    <svg viewBox="0 0 900 500">
      <defs>
        <linearGradient id="login-chart-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2563EB" stopOpacity=".22" />
          <stop offset="100%" stopColor="#2563EB" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g className="grid">
        <line x1="90" y1="80" x2="760" y2="80" />
        <line x1="90" y1="160" x2="760" y2="160" />
        <line x1="90" y1="240" x2="760" y2="240" />
        <line x1="90" y1="320" x2="760" y2="320" />
        <line x1="90" y1="400" x2="760" y2="400" />
      </g>
      <g opacity=".15">
        <circle className="float" cx="110" cy="50" r="2" fill="#2563EB" />
        <circle className="float" cx="650" cy="60" r="3" fill="#8B5CF6" />
        <circle className="float" cx="800" cy="120" r="2" fill="#22C55E" />
      </g>
      <rect className="bar" x="140" y="270" width="10" height="130" rx="5" fill="#93C5FD" />
      <rect className="bar" x="220" y="230" width="10" height="170" rx="5" fill="#60A5FA" />
      <rect className="bar" x="300" y="180" width="10" height="220" rx="5" fill="#2563EB" />
      <rect className="bar" x="380" y="245" width="10" height="155" rx="5" fill="#3B82F6" />
      <rect className="bar" x="460" y="150" width="10" height="250" rx="5" fill="#2563EB" />
      <path
        className="area"
        fill="url(#login-chart-grad)"
        d="M145 300 C190 260 250 230 305 170 S390 210 465 140 S560 190 620 170 L620 400 L145 400Z"
      />
      <path
        className="line"
        d="M145 300 C190 260 250 230 305 170 S390 210 465 140 S560 190 620 170"
        fill="none"
        stroke="#2563EB"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <g fill="#2563EB">
        <circle className="dot" cx="145" cy="300" r="4" />
        <circle className="dot" cx="305" cy="170" r="4" />
        <circle className="dot" cx="465" cy="140" r="4" />
        <circle className="dot" cx="620" cy="170" r="4" />
      </g>
      <g className="card card-1">
        <rect x="680" y="80" width="96" height="40" rx="12" fill="white" stroke="#E2E8F0" />
        <text x="728" y="100" textAnchor="middle" dominantBaseline="middle" fontSize="16" fill="#2563EB">
          ↗ 18.4%
        </text>
      </g>
      <g className="card card-2">
        <rect x="650" y="300" width="96" height="40" rx="12" fill="white" stroke="#E2E8F0" />
        <text x="698" y="320" textAnchor="middle" dominantBaseline="middle" fontSize="20" fill="#0f172a">
          842
        </text>
      </g>
    </svg>
  </ChartWrap>
);

const grow = keyframes`to { transform: scaleY(1); }`;
const draw = keyframes`to { stroke-dashoffset: 0; }`;
const fadeIn = keyframes`to { opacity: 1; }`;
const pop = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const cardIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: none; }
`;
const floatY = keyframes`50% { transform: translateY(-4px); }`;

const ChartWrap = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    max-width: 820px;
    font-family: ${({ theme }) => theme.font.sans};
  }

  .grid line {
    stroke: #eef2f7;
  }

  .bar {
    transform-origin: bottom;
    transform-box: fill-box;
    transform: scaleY(0);
    animation: ${grow} 0.7s forwards;
  }
  .bar:nth-of-type(1) { animation-delay: 0.4s; }
  .bar:nth-of-type(2) { animation-delay: 0.5s; }
  .bar:nth-of-type(3) { animation-delay: 0.6s; }
  .bar:nth-of-type(4) { animation-delay: 0.7s; }
  .bar:nth-of-type(5) { animation-delay: 0.8s; }

  .line {
    stroke-dasharray: 900;
    stroke-dashoffset: 900;
    animation: ${draw} 1.5s ease forwards 1s;
  }

  .area {
    opacity: 0;
    animation: ${fadeIn} 1.5s ease forwards 1s;
  }

  .dot {
    opacity: 0;
    animation: ${pop} 0.3s forwards;
  }
  .dot:nth-of-type(1) { animation-delay: 2s; }
  .dot:nth-of-type(2) { animation-delay: 2.1s; }
  .dot:nth-of-type(3) { animation-delay: 2.2s; }
  .dot:nth-of-type(4) { animation-delay: 2.3s; }

  .card {
    opacity: 0;
    animation: ${cardIn} 0.6s forwards;
  }
  .card-1 { animation-delay: 2.4s; }
  .card-2 { animation-delay: 2.8s; }

  .float {
    animation: ${floatY} 5s ease-in-out infinite;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
